const HOT_KEYS =  Object.freeze({
    "HelpMode": "ctrl+shift+s",
    "CopyMeta": "ctrl+c",
    "PasteMeta": "ctrl+v"
})

export default HOT_KEYS;